module.exports = __webpack_public_path__ + "img/google-display-phone-apps.096ec33d.png";